export default __webpack_public_path__ + "static/process-03-9a47eba71e077acffd59c64cd44279b9.svg";